import { render, staticRenderFns } from "./ArchiveFilter.vue?vue&type=template&id=19cd8906&scoped=true&"
import script from "./ArchiveFilter.vue?vue&type=script&lang=ts&"
export * from "./ArchiveFilter.vue?vue&type=script&lang=ts&"
import style0 from "./ArchiveFilter.vue?vue&type=style&index=0&id=19cd8906&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cd8906",
  null
  
)

export default component.exports